export default {"src":"/_next/static/media/funding_circle_logo.07876fdc.svg","height":91,"width":284,"blurWidth":0,"blurHeight":0};